import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from 'chameleon/ui-stack/ui/base/icon';

export const WARNING = {
  COLOR: 'bg-yellow-100',
  ICON: 'warning_triangle',
};

export const INFO = {
  COLOR: 'bg-blue-100',
  ICON: 'info_circle_blue_18',
};

export const TEST_SELECTOR = {
  CONTAINER: 'info-message-banner',
  CHILDREN: 'info-message-children-container',
};

const InfoMessage = ({
  isWarning,
  children,
  className,
  containerAccessibility,
  iconClassName,
  iconAccessibility,
}) => (
  <div
    data-test-id={TEST_SELECTOR.CONTAINER}
    className={cn(
      'flex text-base text-gray-900 px-4.6 py-4.2 rounded-lg',
      {
        [WARNING.COLOR]: isWarning,
        [INFO.COLOR]: !isWarning,
      },
      className,
    )}
    {...(containerAccessibility || {})}
  >
    <div className="flex self-center text-[#E4BE1D]">
      <Icon
        accessibility={{
          title: isWarning ? 'Warning' : 'Info',
          ...iconAccessibility,
        }}
        id={isWarning ? WARNING.ICON : INFO.ICON}
        className={iconClassName}
      />
    </div>
    <span
      className="fl-1 ml-4.2 leading-8 font-normal"
      data-test-id={TEST_SELECTOR.CHILDREN}
    >
      {children}
    </span>
  </div>
);

InfoMessage.propTypes = {
  isWarning: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

InfoMessage.defaultProps = {
  isWarning: false,
};

export default InfoMessage;
